/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BankAccountTypeEnum } from './BankAccountTypeEnum';
import {
    BankAccountTypeEnumFromJSON,
    BankAccountTypeEnumFromJSONTyped,
    BankAccountTypeEnumToJSON,
} from './BankAccountTypeEnum';
import type { Bond } from './Bond';
import {
    BondFromJSON,
    BondFromJSONTyped,
    BondToJSON,
} from './Bond';
import type { BondsDeliveryMethodEnum } from './BondsDeliveryMethodEnum';
import {
    BondsDeliveryMethodEnumFromJSON,
    BondsDeliveryMethodEnumFromJSONTyped,
    BondsDeliveryMethodEnumToJSON,
} from './BondsDeliveryMethodEnum';
import type { BonusTypeEnum } from './BonusTypeEnum';
import {
    BonusTypeEnumFromJSON,
    BonusTypeEnumFromJSONTyped,
    BonusTypeEnumToJSON,
} from './BonusTypeEnum';
import type { DocumentsDeliveryMethodEnum } from './DocumentsDeliveryMethodEnum';
import {
    DocumentsDeliveryMethodEnumFromJSON,
    DocumentsDeliveryMethodEnumFromJSONTyped,
    DocumentsDeliveryMethodEnumToJSON,
} from './DocumentsDeliveryMethodEnum';
import type { Investor } from './Investor';
import {
    InvestorFromJSON,
    InvestorFromJSONTyped,
    InvestorToJSON,
} from './Investor';
import type { Issue } from './Issue';
import {
    IssueFromJSON,
    IssueFromJSONTyped,
    IssueToJSON,
} from './Issue';
import type { Mediator } from './Mediator';
import {
    MediatorFromJSON,
    MediatorFromJSONTyped,
    MediatorToJSON,
} from './Mediator';
import type { OrderStateEnum } from './OrderStateEnum';
import {
    OrderStateEnumFromJSON,
    OrderStateEnumFromJSONTyped,
    OrderStateEnumToJSON,
} from './OrderStateEnum';
import type { Ownership } from './Ownership';
import {
    OwnershipFromJSON,
    OwnershipFromJSONTyped,
    OwnershipToJSON,
} from './Ownership';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * 
 * @export
 * @interface PatchedOrder
 */
export interface PatchedOrder {
    /**
     * 
     * @type {number}
     * @memberof PatchedOrder
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrder
     */
    issueId?: number;
    /**
     * 
     * @type {Issue}
     * @memberof PatchedOrder
     */
    readonly issue?: Issue;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrder
     */
    investorId?: number;
    /**
     * 
     * @type {Investor}
     * @memberof PatchedOrder
     */
    readonly investor?: Investor;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrder
     */
    mediatorId?: number;
    /**
     * 
     * @type {Mediator}
     * @memberof PatchedOrder
     */
    readonly mediator?: Mediator;
    /**
     * 
     * @type {Array<Bond>}
     * @memberof PatchedOrder
     */
    readonly bonds?: Array<Bond>;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrder
     */
    readonly value?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    readonly paidValue?: string;
    /**
     * 
     * @type {Date}
     * @memberof PatchedOrder
     */
    readonly activationDate?: Date;
    /**
     * 
     * @type {Array<Bond>}
     * @memberof PatchedOrder
     */
    readonly reinvestmentBonds?: Array<Bond>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedOrder
     */
    readonly isMigrated?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PatchedOrder
     */
    readonly orderCreatedAt?: Date;
    /**
     * 
     * @type {Array<number>}
     * @memberof PatchedOrder
     */
    reinvestmentBondIds?: Array<number>;
    /**
     * 
     * @type {Array<Ownership>}
     * @memberof PatchedOrder
     */
    readonly ownerships?: Array<Ownership>;
    /**
     * 
     * @type {Array<Ownership>}
     * @memberof PatchedOrder
     */
    readonly reinvestmentOwnerships?: Array<Ownership>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PatchedOrder
     */
    readonly validationResult?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PatchedOrder
     */
    readonly validationTimeline?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof PatchedOrder
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedOrder
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrder
     */
    externalId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedOrder
     */
    isReinvestment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedOrder
     */
    reinvestmentBondsReceived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    deliveryCodeDocuments?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    deliveryCodeBonds?: string;
    /**
     * 
     * @type {Date}
     * @memberof PatchedOrder
     */
    documentsSent?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedOrder
     */
    bondsSent?: Date;
    /**
     * 
     * @type {BonusTypeEnum}
     * @memberof PatchedOrder
     */
    bonusType?: BonusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    bonus?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    bankAccountNumberPrincipal?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    bankAccountNumberInterest?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    variableSymbolPrincipal?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    specificSymbolPrincipal?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    variableSymbolInterest?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    specificSymbolInterest?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    promoCode?: string;
    /**
     * 
     * @type {BankAccountTypeEnum}
     * @memberof PatchedOrder
     */
    bankAccountTypeInterest?: BankAccountTypeEnum;
    /**
     * 
     * @type {BankAccountTypeEnum}
     * @memberof PatchedOrder
     */
    bankAccountTypePrincipal?: BankAccountTypeEnum;
    /**
     * 
     * @type {OrderStateEnum}
     * @memberof PatchedOrder
     */
    state?: OrderStateEnum;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrder
     */
    amount?: number;
    /**
     * 
     * @type {DocumentsDeliveryMethodEnum}
     * @memberof PatchedOrder
     */
    documentsDeliveryMethod?: DocumentsDeliveryMethodEnum;
    /**
     * 
     * @type {BondsDeliveryMethodEnum}
     * @memberof PatchedOrder
     */
    bondsDeliveryMethod?: BondsDeliveryMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    mediatorCommissionNet?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrder
     */
    note?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PatchedOrder
     */
    metadata?: { [key: string]: any; };
}

/**
 * Check if a given object implements the PatchedOrder interface.
 */
export function instanceOfPatchedOrder(value: object): boolean {
    return true;
}

export function PatchedOrderFromJSON(json: any): PatchedOrder {
    return PatchedOrderFromJSONTyped(json, false);
}

export function PatchedOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'issueId': json['issue_id'] == null ? undefined : json['issue_id'],
        'issue': json['issue'] == null ? undefined : IssueFromJSON(json['issue']),
        'investorId': json['investor_id'] == null ? undefined : json['investor_id'],
        'investor': json['investor'] == null ? undefined : InvestorFromJSON(json['investor']),
        'mediatorId': json['mediator_id'] == null ? undefined : json['mediator_id'],
        'mediator': json['mediator'] == null ? undefined : MediatorFromJSON(json['mediator']),
        'bonds': json['bonds'] == null ? undefined : ((json['bonds'] as Array<any>).map(BondFromJSON)),
        'value': json['value'] == null ? undefined : json['value'],
        'paidValue': json['paid_value'] == null ? undefined : json['paid_value'],
        'activationDate': json['activation_date'] == null ? undefined : (dayjs.tz(json['activation_date'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'reinvestmentBonds': json['reinvestment_bonds'] == null ? undefined : ((json['reinvestment_bonds'] as Array<any>).map(BondFromJSON)),
        'isMigrated': json['is_migrated'] == null ? undefined : json['is_migrated'],
        'orderCreatedAt': json['order_created_at'] == null ? undefined : (dayjs(json['order_created_at']).toDate()),
        'reinvestmentBondIds': json['reinvestment_bond_ids'] == null ? undefined : json['reinvestment_bond_ids'],
        'ownerships': json['ownerships'] == null ? undefined : ((json['ownerships'] as Array<any>).map(OwnershipFromJSON)),
        'reinvestmentOwnerships': json['reinvestment_ownerships'] == null ? undefined : ((json['reinvestment_ownerships'] as Array<any>).map(OwnershipFromJSON)),
        'validationResult': json['validation_result'] == null ? undefined : json['validation_result'],
        'validationTimeline': json['validation_timeline'] == null ? undefined : json['validation_timeline'],
        'createdAt': json['created_at'] == null ? undefined : (dayjs(json['created_at']).toDate()),
        'updatedAt': json['updated_at'] == null ? undefined : (dayjs(json['updated_at']).toDate()),
        'externalId': json['external_id'] == null ? undefined : json['external_id'],
        'isReinvestment': json['is_reinvestment'] == null ? undefined : json['is_reinvestment'],
        'reinvestmentBondsReceived': json['reinvestment_bonds_received'] == null ? undefined : json['reinvestment_bonds_received'],
        'deliveryCodeDocuments': json['delivery_code_documents'] == null ? undefined : json['delivery_code_documents'],
        'deliveryCodeBonds': json['delivery_code_bonds'] == null ? undefined : json['delivery_code_bonds'],
        'documentsSent': json['documents_sent'] == null ? undefined : (dayjs(json['documents_sent']).toDate()),
        'bondsSent': json['bonds_sent'] == null ? undefined : (dayjs.tz(json['bonds_sent'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'bonusType': json['bonus_type'] == null ? undefined : BonusTypeEnumFromJSON(json['bonus_type']),
        'bonus': json['bonus'] == null ? undefined : json['bonus'],
        'bankAccountNumberPrincipal': json['bank_account_number_principal'] == null ? undefined : json['bank_account_number_principal'],
        'bankAccountNumberInterest': json['bank_account_number_interest'] == null ? undefined : json['bank_account_number_interest'],
        'variableSymbolPrincipal': json['variable_symbol_principal'] == null ? undefined : json['variable_symbol_principal'],
        'specificSymbolPrincipal': json['specific_symbol_principal'] == null ? undefined : json['specific_symbol_principal'],
        'variableSymbolInterest': json['variable_symbol_interest'] == null ? undefined : json['variable_symbol_interest'],
        'specificSymbolInterest': json['specific_symbol_interest'] == null ? undefined : json['specific_symbol_interest'],
        'promoCode': json['promo_code'] == null ? undefined : json['promo_code'],
        'bankAccountTypeInterest': json['bank_account_type_interest'] == null ? undefined : BankAccountTypeEnumFromJSON(json['bank_account_type_interest']),
        'bankAccountTypePrincipal': json['bank_account_type_principal'] == null ? undefined : BankAccountTypeEnumFromJSON(json['bank_account_type_principal']),
        'state': json['state'] == null ? undefined : OrderStateEnumFromJSON(json['state']),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'documentsDeliveryMethod': json['documents_delivery_method'] == null ? undefined : DocumentsDeliveryMethodEnumFromJSON(json['documents_delivery_method']),
        'bondsDeliveryMethod': json['bonds_delivery_method'] == null ? undefined : BondsDeliveryMethodEnumFromJSON(json['bonds_delivery_method']),
        'mediatorCommissionNet': json['mediator_commission_net'] == null ? undefined : json['mediator_commission_net'],
        'note': json['note'] == null ? undefined : json['note'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function PatchedOrderToJSON(value?: PatchedOrder | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'issue_id': value['issueId'],
        'investor_id': value['investorId'],
        'mediator_id': value['mediatorId'],
        'reinvestment_bond_ids': value['reinvestmentBondIds'],
        'external_id': value['externalId'],
        'is_reinvestment': value['isReinvestment'],
        'reinvestment_bonds_received': value['reinvestmentBondsReceived'],
        'delivery_code_documents': value['deliveryCodeDocuments'],
        'delivery_code_bonds': value['deliveryCodeBonds'],
        'documents_sent': value['documentsSent'] == null ? undefined : (dayjs(value['documentsSent'] as any).toISOString()),
        'bonds_sent': value['bondsSent'] == null ? undefined : (dayjs(value['bondsSent'] as any).format('YYYY-MM-DD')),
        'bonus_type': BonusTypeEnumToJSON(value['bonusType']),
        'bonus': value['bonus'],
        'bank_account_number_principal': value['bankAccountNumberPrincipal'],
        'bank_account_number_interest': value['bankAccountNumberInterest'],
        'variable_symbol_principal': value['variableSymbolPrincipal'],
        'specific_symbol_principal': value['specificSymbolPrincipal'],
        'variable_symbol_interest': value['variableSymbolInterest'],
        'specific_symbol_interest': value['specificSymbolInterest'],
        'promo_code': value['promoCode'],
        'bank_account_type_interest': BankAccountTypeEnumToJSON(value['bankAccountTypeInterest']),
        'bank_account_type_principal': BankAccountTypeEnumToJSON(value['bankAccountTypePrincipal']),
        'state': OrderStateEnumToJSON(value['state']),
        'amount': value['amount'],
        'documents_delivery_method': DocumentsDeliveryMethodEnumToJSON(value['documentsDeliveryMethod']),
        'bonds_delivery_method': BondsDeliveryMethodEnumToJSON(value['bondsDeliveryMethod']),
        'mediator_commission_net': value['mediatorCommissionNet'],
        'note': value['note'],
        'metadata': value['metadata'],
    };
}

